"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configurationDataAuditFromResource = exports.isConfigurationDataAuditInstant = void 0;
const temporal_luxon_1 = require("temporal-luxon");
/**
 * Matches what Nucleus DateTimeFormat will Instant.from, plus a `T` requirement so a
 * date-only value is not silently rendered as midnight UTC.
 */
const isConfigurationDataAuditInstant = (at) => {
    if (!at.includes('T')) {
        return false;
    }
    try {
        temporal_luxon_1.Instant.from(at);
        return true;
    }
    catch (_a) {
        return false;
    }
};
exports.isConfigurationDataAuditInstant = isConfigurationDataAuditInstant;
const configurationDataAuditFromResource = (value) => {
    if (!Array.isArray(value)) {
        return [];
    }
    return value.filter((entry) => !!entry &&
        typeof entry === 'object' &&
        typeof entry.at === 'string' &&
        (0, exports.isConfigurationDataAuditInstant)(entry.at) &&
        typeof entry.author === 'string');
};
exports.configurationDataAuditFromResource = configurationDataAuditFromResource;
//# sourceMappingURL=configuration_data_audit.js.map